import { render, staticRenderFns } from "./colleagueOrder.vue?vue&type=template&id=3e100601&scoped=true&"
import script from "./colleagueOrder.vue?vue&type=script&lang=js&"
export * from "./colleagueOrder.vue?vue&type=script&lang=js&"
import style0 from "./colleagueOrder.vue?vue&type=style&index=0&id=3e100601&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e100601",
  null
  
)

export default component.exports